/** The held field the event commands sidebar shows, and that its Review opener covers (GH #1912) */
export const eventCommandsFields = ['eventCommands'] as const
